import React from 'react';
import {
  Box,
  CreateNoteButton,
  NotesList,
} from '../../../../common/components';
import { Col, Row } from 'react-bootstrap';
import { InternalButtonBar } from '../../../layout/components';

const ComplaintNotes = ({ resource }) => {
  return (
    <Box>
      <h2 className="resource-name">Complaint</h2>

      <NotesList
        resourceId={resource.data.id}
      />

      <Row>
        <Col sm={12}>
          <InternalButtonBar
            buttons={[
              {
                button: (
                  <CreateNoteButton
                    label="Add a Note"
                    notableResource={resource}
                    notableResourceType="complaint"
                  />
                ),
              },
            ]}
          />
        </Col>
      </Row>
    </Box>
  );
};

export default ComplaintNotes;
